import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { ISensorData } from "@app/interfaces/ISensorData";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root'
})
export class FoundationSensorDataService {
    constructor(private readonly http: HttpClient) { }

    getSensorDataForVehicle(vehicleId: number, start: Date, end = new Date()): Observable<ISensorData[]> {
            return this.http.get<ISensorData[]>(`/api/sensorData/${vehicleId}?start=${start.toISOString()}&end=${end.toISOString()}`,
                {
                    params: {
                        start: start.toISOString(),
                        end: end.toISOString()
                    }
                })
    }

    getSensorDataByImei(imei: string, startTime: Date, endTime: Date): Observable<ISensorData[]> {

        return this.http.get<ISensorData[]>(`/api/foundation/units/${imei}/sensordata`, {
            params: {
                start: startTime.toISOString(),
                end: endTime.toISOString()
            }
        });
    }
}
